<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button>
        </div>

        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无黑名单用户" height="600">
                <el-table-column type="selection"   width="80"          align="center"> </el-table-column>
                <el-table-column prop="phone"       label="手机号"       width="120" align="center"> </el-table-column>
                <el-table-column prop="created_at"  label="创建时间"     width="160" align="center"   ></el-table-column>
                <el-table-column prop="updated_at"  label="登录时间"     width="160" align="center"></el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
         </el-card>

        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>手机号码：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="phone" placeholder="请输入手机号码"></el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { blacklist, blacklist_add, blacklist_del } from '@/api/platform.js'

export default {
    data() {
        return {
            tableData: [],
            page:1,
            size:20,
            total:0,
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
            dialogTitle:'添加黑名单用户',
            id:'',           //  有id 是修改  没有id是添加
            phone:'',
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            let params = {
                page:this.page
            }
            blacklist(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            })
        },
        // 显示添加修改弹窗
        handleShow(){
            this.dialog      = true
            this.dialogTitle = '添加黑名单用户'
            this.phone       = ''
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            this.handleAdd()
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                phone:this.phone,
            }
            blacklist_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(it){
            this.$confirm(`此操作将删除 ${it.nickname} 黑名单用户, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                blacklist_del(it.id).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>